import React, { Fragment, useState, useEffect } from 'react'

// react router
import { NavLink, useHistory } from 'react-router-dom'

// user context
import { useGraphQLDatas } from '../UserContext'

// images
import logo from '../../../../images/logo.svg'

// semantic-ui
import {
  Menu,
  Image,
  Dropdown,
  Icon
} from 'semantic-ui-react'

// styles
import './index.css'

function Topbar (props)  {
  let [me, setMe] = useState(null)

  let { loading, data } = useGraphQLDatas()

  let history = useHistory()

  useEffect(() => {
    if (data && !loading) {
      setMe(data.me)
    }
  }, [data])

  const handleEditUserLink = () => {
    history.push(`/users/${me.id}`)
  }

  return (
    <div className='Topbar'>
      <Menu fixed='top' stackable>
        <Menu.Item className='image' header as={NavLink} to='/' exact>
          <Image src={logo} />
        </Menu.Item>

        <Menu.Item as={NavLink} to='/devices'>Devices</Menu.Item>
        <Menu.Item as={NavLink} to='/sensors'>Sensors</Menu.Item>
        {me && me.admin && (
          <Menu.Item as={NavLink} to='/users'>Users</Menu.Item>
        )}

        <Menu.Menu position='right' className='jobs-menu'>
          {!me && (
            <Menu.Item as={NavLink} to='/logout'>
              Logout
            </Menu.Item>
          )}
          {me && (
            <Dropdown
              item
              className='image'
              trigger={
                <Fragment>
                  <Image
                    avatar
                    src={'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=' + me.name}
                  />
                    {me.name}
                </Fragment>
              }
            >
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleEditUserLink}>
                  <Icon name='user' />
                  Profile
                </Dropdown.Item>
                <Dropdown.Item onClick={() => history.push('/logout')}>
                  <Icon name='sign out' />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Menu.Menu>
      </Menu>
    </div>
  )
}

export default Topbar
